"use strict";
var ESCAPE_KEY_CODE = 27;
function handleEscapeKeydown(element, callback) {
    element.addEventListener('keydown', function (event) {
        var key = event.keyCode || event.which;
        if (key === ESCAPE_KEY_CODE) {
            callback(event);
        }
    }, true);
}
exports.handleEscapeKeydown = handleEscapeKeydown;
//# sourceMappingURL=domEventHandler.js.map